import React, { Component } from 'react';
import { Form, Control, Errors, Fieldset } from 'react-redux-form';
import {required} from "../field_validations";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import DateTimePick from './../forms/datetimepicker';
import TextEditor from "../forms/wysiwyg_field";
import {toInt} from "../parsers";
import Rating from 'react-rating';

export default class GroupPhaseEdit extends Component {
	render(){
		const { phases, version_groups_phases, notifications_types, modalities, match, projects, entities, surveys } = this.props;
		let gpc = _.find(version_groups_phases.permissions, (o) => {return o === 'Create'});
		let gpu = _.find(version_groups_phases.permissions, (o) => {return o === 'Update'});
		let gpd = _.find(version_groups_phases.permissions, (o) => {return o === 'Delete'});
		let gpsa = _.find(version_groups_phases.permissions, (o) => {return o === 'SuperAdmin'});
		let phaseData = version_groups_phases.edit.temp_id_phase ? _.find(phases.list,{id: _.toNumber(version_groups_phases.edit.temp_id_phase)}):undefined;

		console.log('GPC ==> ', version_groups_phases);
		return (
			<div className="columns is-centered">
				<Form model="version_groups_phases.edit" className="column is-10" onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
					<p className="title is-5">{version_groups_phases.edit && version_groups_phases.edit.name}</p>
					<div className="hero is-light">
						<div className="hero-body">
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="start_date" className="label">Inicia <span className="small has-text-danger">*</span></label>
									<Control.text model=".start_date" name="start_date" id="start_date" component={DateTimePick} className="input" errors={{required}} validateOn="change" disabled={gpu ? false:true}/>
									<Errors model=".start_date" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La fecha es obligatorio'}}/>
								</div>

								<div className="control is-expanded">
									<label htmlFor="end_date" className="label">Termina <span className="small has-text-danger">*</span></label>
									<Control.text model=".end_date" name="end_date" id="end_date" component={DateTimePick} className="input" errors={{required}} validateOn="change" disabled={gpu ? false:true}/>
									<Errors model=".end_date" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La fecha es obligatorio'}}/>
								</div>
							</div>

							{gpsa ?
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="report_start_date" className="label">Inicia reporte</label>
									<Control.text model=".report_start_date" name="report_start_date" id="report_start_date" component={DateTimePick} className="input" />
									<Errors model=".report_start_date" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La fecha es obligatorio'}}/>
								</div>

								<div className="control is-expanded">
									<label htmlFor="report_end_date" className="label">Termina reporte</label>
									<Control.text model=".report_end_date" name="report_end_date" id="report_end_date" component={DateTimePick} className="input" />
									<Errors model=".report_end_date" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La fecha es obligatorio'}}/>
								</div>
							</div> :''}

							<div className="field is-grouped">
								<div className="control">
									<div className="message is-success">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="all_projects" className="checkbox">
														<Control.checkbox model=".all_projects" id="all_projects" className="checkbox" isToggle={true} disabled={gpu ? false:true} changeAction={(model,value) => this._changeAllProject(model,value)}/>
														<span style={{whiteSpace:'normal'}}> Aplica para todos los proyectos </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="control">
									<div className="message is-info">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="show_current_revision" className="checkbox">
														<Control.checkbox model=".show_current_revision" id="show_current_revision" className="checkbox" disabled={gpu ? false:true} isToggle={true}/>
														<span style={{whiteSpace:'normal'}}> Ver revisión actual </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="control">
									<div className="message is-primary">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="assign_codes" className="checkbox">
														<Control.checkbox model=".assign_codes" id="assign_codes" className="checkbox" disabled={gpu ? false:true} isToggle={true}/>
														<span style={{whiteSpace:'normal'}}> Proceso asignación de folios </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<hr />

					<div className="tabs is-boxed is-fullwidth is-centered no-margin-bottom">
						<ul>
							<li className={this.state.tabId === 1 ? 'is-active':''}>
								<a onClick={() => this._changeTab(1)}>
									<span className="icon is-small"><i className="fa fa-gear" /></span>
									<span>Subproceso</span>
								</a>
							</li>
							<li className={this.state.tabId === 2 ? 'is-active':''} disabled>
								<a onClick={() => this._changeTab(2)}>
									<span className="icon is-small"><i className="fa fa-check-square-o" /></span>
									<span>Revisiones</span>
								</a>
							</li>
							<li className={this.state.tabId === 3 ? 'is-active':''} disabled>
								<a onClick={() => this._changeTab(3)}>
									<span className="icon is-small"><i className="fa fa-bell" /></span>
									<span>Notificaciones</span>
								</a>
							</li>

							{!version_groups_phases.edit.all_projects && !_.isEmpty(projects.list) ?
								<li className={this.state.tabId === 4 ? 'is-active':''} disabled>
									<a onClick={() => this._changeTab(4)}>
										<span className="icon is-small"><i className="fa fa-briefcase" /></span>
										<span>Proyectos</span>
									</a>
								</li>
								:''}
						</ul>
					</div>

					{this.state.tabId === 1 &&
						<div className="hero is-light">
							<div className="hero-body">
								{gpc ?
								<div className="hero-subsection">
									<h5 className="title is-5">Añadir Subproceso</h5>
									<div className="field is-grouped is-grouped-multiline">
										<div className="control is-expanded">
											<label htmlFor="temp_p_start_date" className="label">Inicia Subproceso <span className="small has-text-danger">*</span></label>
											<Control.text
												model=".temp_p_start_date"
												name="temp_p_start_date"
												id="temp_p_start_date"
												value={version_groups_phases.edit.temp_p_start_date ? version_groups_phases.edit.temp_p_start_date:undefined}
												component={DateTimePick}
												className="input"
											/>
											{version_groups_phases.edit.temp_p_start_date ? '':
												<small className="help has-text-danger">Fecha requerida</small>}
										</div>

										<div className="control is-expanded">
											<label htmlFor="temp_p_end_date" className="label">Termina Subproceso <span className="small has-text-danger">*</span></label>
											<Control.text model=".temp_p_end_date"
											              name="temp_p_end_date"
											              id="temp_p_end_date"
											              value={version_groups_phases.edit.temp_p_end_date ? version_groups_phases.edit.temp_p_end_date:undefined}
											              component={DateTimePick}
											              className="input" />
											{version_groups_phases.edit.temp_p_end_date ? '':
												<small className="help has-text-danger">Fecha requerida</small>}
										</div>
									</div>

									<div className="field has-addons">
										<div className="control">
											<label htmlFor="groups_phase" className="label">Subproceso <span className="small has-text-danger">*</span></label>
											<div className="select">
												<Control.select model=".temp_id_phase"
												                name="temp_id_phase"
												                id="temp_id_phase"
												                value={version_groups_phases.edit.temp_id_phase ? version_groups_phases.edit.temp_id_phase:""}>
													<option value="">-- Seleccionar Subproceso --</option>
													{_.map(_.filter(phases.list, {type: 'project'}), (opt, k) => {
														let findPhase = _.find(version_groups_phases.edit.phases,{id: opt.id}) ? false:true;

														if(findPhase){
															return <option key={k} value={opt.id}>{opt.name}</option>
														}
													})}
												</Control.select>
											</div>
											{version_groups_phases.edit.temp_id_phase ? '':
												<small className="help has-text-danger">Subproceso requerido</small>}
										</div>

										{phaseData && phaseData.require_survey ?
										'':<div className="control">
												<label className="label">&nbsp;</label>
												<button type="button" className="button is-info" onClick={() => {this._addPhase()}} disabled={this._validPhase(version_groups_phases.edit.temp_id_phase)}>Agregar</button>
											</div>}
									</div>

									{phaseData && phaseData.require_survey ?
									<div>
										<h5 className="title is-5">{`Añadir encuestas`}</h5>
										{this._validSurvey() ?
										<div className="field is-grouped">
											<div className="control">
												<div className="message is-success">
													<div className="message-body">
														<div className="field">
															<div className="control">
																<label htmlFor="temp_all_mods" className="checkbox">
																	<Control.checkbox model=".temp_all_mods" id="temp_all_mods" className="checkbox" isToggle={true}/>
																	<span style={{whiteSpace:'normal'}}> Aplica para todas las modalidades </span>
																</label>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>:''}

										{this._validSurvey() ?
											<div className="field has-addons">
												<div className="control">
													<label htmlFor="groups_phase" className="label">Encuesta <span className="small has-text-danger">*</span></label>
													<div className="select">
														<Control.select model=".temp_survey_id"
														                name="temp_survey_id"
														                id="temp_survey_id"
														                value={version_groups_phases.edit.temp_survey_id ? version_groups_phases.edit.temp_survey_id:""}
														                parser={ toInt }>
															<option value="">-- Seleccionar Encuesta --</option>
															{_.map(surveys.list, (opt, k) => {
																return <option key={k} value={opt.id}>{opt.name}</option>
															})}
														</Control.select>
													</div>
													{version_groups_phases.edit.temp_survey_id ? '':
														<small className="help has-text-danger">Encuesta requerido</small>}
												</div>

												{!version_groups_phases.edit.temp_all_mods ?
													<div className="control">
														<label htmlFor="temp_modality_id" className="label">Modalidad</label>
														<div className="select">
															<Control.select model=".temp_modality_id" id="temp_modality_id" parser={ toInt } >
																<option value=" " defaultValue>--- Modalidad ---</option>
																{_.map(modalities.list,(option, k) => {
																	return <option value={option.id} key={k}>{option.name}</option>
																})}
															</Control.select>
														</div>
													</div> :''}

												<div className="control">
													<label className="label">&nbsp;</label>
													<button type="button" className="button is-info" onClick={() => this._addSurveys()} disabled={this._validMod(version_groups_phases.edit.temp_modality_id)}>Agregar</button>
												</div>
											</div>:''}

										{_.map(version_groups_phases.edit.temp_survey_version_phases, (row, s) => {
											return (
												<span className="tag is-success is-medium" key={s}>
													{`${row.name}${row.modality_id ? ` - ${row.modality.name}`:''}`}
													<button type="button" className="delete" onClick={() => this.props.remove('version_groups_phases.edit.temp_survey_version_phases',s)}></button>
												</span>
											)
										})}
									</div>
									:''}
									<br/>
									{phaseData && phaseData.require_survey ?
									<div className="field is-grouped is-grouped-right">
										<div className="control">
											<button type="button" className="button is-medium is-info" onClick={() => {this._addPhase()}} disabled={this._validPhase(version_groups_phases.edit.temp_id_phase)}>Agregar</button>
										</div>
									</div>:''}
								</div> : <p className="has-text-danger">No tienes permiso para editar subprocesos</p>}

								<hr/>

								{(!_.isEmpty(version_groups_phases.edit.phases) && !_.isEmpty(_.filter(version_groups_phases.edit.phases,{type: 'project'}))) &&
								<div className="hero-subsection">
									<p className="title is-5" style={{marginBottom:'-30px'}}>Listado de Subprocesos</p>
									<table className="table is-fullwidth project-goal-table">
										<thead>
										<tr>
											<th>#</th>
											<th>Nombre</th>
											<th></th>
											<th>Acciones</th>
										</tr>
										</thead>
										{_.map(_.filter(version_groups_phases.edit.phases,{type: 'project'}),(row, k) => {
											let phaseIndex = _.findIndex(version_groups_phases.edit.phases,{id: row.id});
											return [
												<Fieldset key={`phases-${row.id}`} model={`.phases[${phaseIndex}]`} component="tbody">
													<tr>
														<td className="goal-cell" style={{width:'5%'}} rowSpan={gpsa ? 3:2}>
															<strong>{k+1}</strong>
														</td>
														<td colSpan={3}>
															{this.state.modalSurveysShow && this.state.phaseId === row.id ?
																<ModelSurveysEdit active={this.state.modalSurveysShow} data={row} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
															<div className="field is-grouped">
																<div className="control">
																	<strong>{row.name}</strong>
																</div>
																{row.require_survey ?
																<div className="control" style={{cursor: 'pointer'}} onClick={()=> this._editSurveys(row.id)}>
																	<div className="tags has-addons">
																		<span className="tag is-medium is-dark"># Encuestas</span>
																		<div className="tag is-medium is-inm-purple">
																			{_.size(row.survey_version_phases)}
																		</div>
																	</div>
																</div>:''}
															</div>
														</td>
													</tr>
													<tr>
														{this.state.editPhase === true && this.state.phaseId === row.id ?
															<td className="date-cell">
																<label htmlFor={`temp_start_date_${row.id}`} className="label">Inicia</label>
																<Control model=".temp_start_date"
																         name={`temp_start_date_${row.id}`}
																         id={`temp_start_date_${row.id}`}
																         defaultValue={version_groups_phases.edit.phases[phaseIndex].temp_start_date ? version_groups_phases.edit.phases[phaseIndex].temp_start_date:version_groups_phases.edit.phases[phaseIndex].start_date}
																         component={DateTimePick}
																         className="input" />
															</td>
															:<td><label className="label">Inicia</label>{row.start_date}</td> }
														{this.state.editPhase === true && this.state.phaseId === row.id ?
															<td className="date-cell">
																<label htmlFor={`temp_end_date_${row.id}`} className="label">Termina</label>
																<Control model=".temp_end_date"
																         name={`temp_end_date_${row.id}`}
																         id={`temp_end_date_${row.id}`}
																         defaultValue={version_groups_phases.edit.phases[phaseIndex].temp_end_date ? version_groups_phases.edit.phases[phaseIndex].temp_end_date:version_groups_phases.edit.phases[phaseIndex].end_date}
																         component={DateTimePick}
																         className="input" />
															</td>
															:<td><label className="label">Termina</label>{row.end_date}</td> }
														<td style={{width:'10%'}} rowSpan={gpsa ? 2:1}>
															<div className="field is-grouped">
																{gpu ?
																<div className="control">
																	{this.state.editPhase === true && this.state.phaseId === row.id ?
																		<button type="button" className="button is-success" onClick={() => this._savePhase(row.id)}><i className="fa fa-save" /></button>
																		:<button type="button" className="button is-info" onClick={() => this._editPhase(row.id)}><i className="fa fa-edit" /></button>}
																</div>:''}
																<div className="control">
																	{this.state.editPhase === true && this.state.phaseId === row.id ?
																		<button type="button" onClick={() => this._closePhase(row.id)} className="button is-warning"><i className="fa fa-times" /></button>
																		:gpd ? <button type="button" onClick={() => this._getConfirm(row.id, row.name)} className="button is-danger"><i className="fa fa-trash" /></button>:''}
																</div>
															</div>
														</td>
													</tr>
													{gpsa ?
													<tr>
														{this.state.editPhase === true && this.state.phaseId === row.id ?
															<td className="date-cell">
																<label htmlFor={`temp_report_start_date_${row.id}`} className="label">Inicia reporte</label>
																<Control model=".temp_report_start_date"
																         name={`temp_report_start_date_${row.id}`}
																         id={`temp_report_start_date_${row.id}`}
																         defaultValue={version_groups_phases.edit.phases[phaseIndex].temp_report_start_date ? version_groups_phases.edit.phases[phaseIndex].temp_report_start_date:version_groups_phases.edit.phases[phaseIndex].report_start_date}
																         component={DateTimePick}
																         className="input" />
															</td>
															:<td><label className="label">Inicia reporte</label>{row.report_start_date}</td> }
														{this.state.editPhase === true && this.state.phaseId === row.id ?
															<td className="date-cell">
																<label htmlFor={`temp_report_end_date_${row.id}`} className="label">Termina reporte</label>
																<Control model=".temp_report_end_date"
																         name={`temp_report_end_date_${row.id}`}
																         id={`temp_report_end_date_${row.id}`}
																         defaultValue={version_groups_phases.edit.phases[phaseIndex].temp_report_end_date ? version_groups_phases.edit.phases[phaseIndex].temp_report_end_date:version_groups_phases.edit.phases[phaseIndex].report_end_date}
																         component={DateTimePick}
																         className="input" />
															</td>
															:<td><label className="label">Termina reporte</label>{row.report_end_date}</td> }
													</tr> :null}
												</Fieldset>
											]
										})}
									</table>
								</div>
								}
							</div>
						</div>
					}

					{(this.state.tabId === 2) &&
						<div className="hero is-light">
							{gpc ?
							<div className="hero-body">
								<h5 className="title is-5">Añadir Revisiones</h5>
								<div className="hero-subsection">
									<div className="field is-grouped is-grouped-multiline">
										<div className="control is-expanded">
											<label htmlFor="temp_p_start_date" className="label">Inicia Revisión <span className="small has-text-danger">*</span></label>
											<Control.text model=".temp_p_start_date"
											              name="temp_p_start_date"
											              id="temp_p_start_date"
											              value={version_groups_phases.edit.temp_p_start_date ? version_groups_phases.edit.temp_p_start_date:undefined}
											              component={DateTimePick}
											              className="input" />
											{version_groups_phases.edit.temp_p_start_date ? '':
												<small className="help has-text-danger">Fecha requerida</small>}
										</div>

										<div className="control is-expanded">
											<label htmlFor="temp_p_end_date" className="label">Termina Revisión <span className="small has-text-danger">*</span></label>
											<Control.text model=".temp_p_end_date"
											              name="temp_p_end_date"
											              id="temp_p_end_date"
											              value={version_groups_phases.edit.temp_p_end_date ? version_groups_phases.edit.temp_p_end_date:undefined}
											              component={DateTimePick}
											              className="input" />
											{version_groups_phases.edit.temp_p_end_date ? '':
												<small className="help has-text-danger">Fecha requerida</small>}
										</div>
									</div>

									<div className="field has-addons">
										<div className="control">
											<label htmlFor="groups_phase" className="label">Revisión <span className="small has-text-danger">*</span></label>
											<div className="select">
												<Control.select model=".temp_id_phase"
												                name="temp_id_phase"
												                id="temp_id_phase"
												                value={version_groups_phases.edit.temp_id_phase ? version_groups_phases.edit.temp_id_phase:""}>
													<option value="">-- Seleccionar Revisión --</option>
													{_.map(_.filter(phases.list, {type: 'revision'}), (opt, k) => {
														let findPhase = _.find(version_groups_phases.edit.phases,{id: opt.id}) ? false:true;

														if(findPhase){
															return <option key={k} value={opt.id}>{opt.name}</option>
														}
													})}
												</Control.select>
											</div>
											{version_groups_phases.edit.temp_id_phase ? '':
												<small className="help has-text-danger">Revisión requerida</small>}
										</div>

										<div className="control">
											<label className="label">&nbsp;</label>
											<button type="button" className="button is-info" onClick={() => {this._addPhase()}} disabled={this._validPhase(version_groups_phases.edit.temp_id_phase)}>Agregar</button>
										</div>
									</div>
								</div>
							</div> :
							<div className="hero-body">
								<p className="has-text-danger">No tienes permisos para editar revisiones</p>
							</div>}

							{(!_.isEmpty(version_groups_phases.edit.phases) && !_.isEmpty(_.filter(version_groups_phases.edit.phases,{type: 'revision'}))) &&
								<div className="hero-body">
									<div className="hero-subsection">
										<label className="label">Listado de revisiones</label>
										<table className="table is-fullwidth project-goal-table">
											<thead>
											<tr>
												<th>#</th>
												<th>Nombre</th>
												<th></th>
												<th>Acciones</th>
											</tr>
											</thead>
											{_.map(_.filter(version_groups_phases.edit.phases,{type: 'revision'}),(row, k) => {
												let phaseIndex = _.findIndex(version_groups_phases.edit.phases,{id: row.id});
												return [
													<Fieldset key={`phases_r_${row.id}`} model={`.phases[${phaseIndex}]`} component="tbody">
														<tr>
															<td className="goal-cell" style={{width:'5%'}} rowSpan={gpsa ? 3:2}>
																<strong>{k+1}</strong>
															</td>
															{/*<td colSpan={3}><strong>{row.name}</strong></td>*/}
															<td colSpan={3}>
																{this.state.modalSurveysShow && this.state.phaseId === row.id ?
																	<ModelSurveysEdit active={this.state.modalSurveysShow} data={row} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
																<div className="field is-grouped">
																	<div className="control">
																		<strong>{row.name}</strong>
																	</div>
																	{row.require_survey ?
																		<div className="control" style={{cursor: 'pointer'}} onClick={()=> this._editSurveys(row.id)}>
																			<div className="tags has-addons">
																				<span className="tag is-medium is-dark"># Encuestas</span>
																				<div className="tag is-medium is-inm-purple">
																					{_.size(row.survey_version_phases)}
																				</div>
																			</div>
																		</div>:''}
																</div>
															</td>
														</tr>
														<tr>
															{this.state.editPhase === true && this.state.phaseId === row.id ?
																<td className="date-cell">
																	<label htmlFor={`temp_start_date_${row.id}`} className="label">Inicia</label>
																	<Control model=".temp_start_date"
																	         name={`temp_start_date_${row.id}`}
																	         id={`temp_start_date_${row.id}`}
																	         defaultValue={version_groups_phases.edit.phases[phaseIndex].temp_start_date ? version_groups_phases.edit.phases[phaseIndex].temp_start_date:version_groups_phases.edit.phases[phaseIndex].start_date}
																	         component={DateTimePick}
																	         className="input"/>
																</td>
																:<td><label className="label">Inicia</label>{row.start_date}</td> }
															{this.state.editPhase === true && this.state.phaseId === row.id ?
																<td className="date-cell">
																	<label htmlFor={`temp_end_date_${row.id}`} className="label">Termina</label>
																	<Control model=".temp_end_date"
																	         name={`temp_end_date_${row.id}`}
																	         id={`temp_end_date_${row.id}`}
																	         defaultValue={version_groups_phases.edit.phases[phaseIndex].temp_end_date ? version_groups_phases.edit.phases[phaseIndex].temp_end_date:version_groups_phases.edit.phases[phaseIndex].end_date}
																	         component={DateTimePick}
																	         className="input" />
																</td>
																:<td><label className="label">Termina</label>{row.end_date}</td> }
															<td style={{width:'10%'}} rowSpan={gpsa ? 2:1}>
																<div className="field is-grouped">
																	{gpu ?
																	<div className="control">
																		{this.state.editPhase === true && this.state.phaseId === row.id ?
																			<button type="button" className="button is-success" onClick={() => this._savePhase(row.id)}><i className="fa fa-save" /></button>
																			:<button type="button" className="button is-info" onClick={() => this._editPhase(row.id)}><i className="fa fa-edit" /></button>}
																	</div>:''}
																	<div className="control">
																		{this.state.editPhase === true && this.state.phaseId === row.id ?
																			<button type="button" onClick={() => this._closePhase(row.id)} className="button is-warning"><i className="fa fa-times" /></button>
																			:gpd ? <button type="button" onClick={() => this._getConfirm(row.id, row.name)} className="button is-danger"><i className="fa fa-trash" /></button>:''}
																	</div>
																</div>
															</td>
														</tr>
														{gpsa ?
															<tr>
																{this.state.editPhase === true && this.state.phaseId === row.id ?
																	<td className="date-cell">
																		<label htmlFor={`temp_report_start_date_${row.id}`} className="label">Inicia reporte</label>
																		<Control model=".temp_report_start_date"
																		         name={`temp_report_start_date_${row.id}`}
																		         id={`temp_report_start_date_${row.id}`}
																		         defaultValue={version_groups_phases.edit.phases[k].temp_report_start_date ? version_groups_phases.edit.phases[k].temp_report_start_date:version_groups_phases.edit.phases[k].report_start_date}
																		         component={DateTimePick}
																		         className="input" />
																	</td>
																	:<td><label className="label">Inicia reporte</label>{row.report_start_date}</td> }
																{this.state.editPhase === true && this.state.phaseId === row.id ?
																	<td className="date-cell">
																		<label htmlFor={`temp_report_end_date_${row.id}`} className="label">Termina reporte</label>
																		<Control model=".temp_report_end_date"
																		         name={`temp_report_end_date_${row.id}`}
																		         id={`temp_report_end_date_${row.id}`}
																		         defaultValue={version_groups_phases.edit.phases[k].temp_report_end_date ? version_groups_phases.edit.phases[k].temp_report_end_date:version_groups_phases.edit.phases[k].report_end_date}
																		         component={DateTimePick}
																		         className="input" />
																	</td>
																	:<td><label className="label">Termina reporte</label>{row.report_end_date}</td> }
															</tr> :null}
													</Fieldset>
												]
											})}
										</table>
									</div>
								</div>
							}
						</div>
					}

					{(this.state.tabId === 3) &&
						<div className="hero is-light">
							{gpc ?
							<div className="hero-body">
								<h5 className="title is-5">Añadir Notificaciones</h5>

								<div className="hero-subsection">
									<div className="field">
										<div className="control">
											<label htmlFor="temp_modality_id" className="label">Modalidad <span className="small has-text-danger">*</span></label>
											<div className="select">
												<Control.select model=".temp_modality_id" id="temp_modality_id" parser={ toInt } >
													<option value=" " defaultValue>--- Modalidad ---</option>
													{modalities.list.map((option, k) => {
														return <option value={option.id} key={k}>{option.name}</option>
													})}
												</Control.select>
											</div>
											{version_groups_phases.edit.temp_modality_id ? '':
												<small className="help has-text-danger">Modalidad requerida</small>}
										</div>
									</div>
									<div className="field">
										<div className="control">
											<label className="label">Claves</label>
											<p>Las siguientes claves pueden ser escritas en la edición mensaje</p>
											<p>{'{#asesor_name#} '} = Nombre Asesor</p>
											<p>{'{#asesor_email#} '} = Email Asesor</p>
											<p>{'{#asesor_extension#} '} = Extensión Asesor</p>
											<label htmlFor={`temp_body`} className="label">Mensaje para notificacion <span className="small has-text-danger">*</span></label>
											<Control.textarea model={`.temp_body`} id={`.temp_body`} component={TextEditor} />
											{version_groups_phases.edit.temp_body && version_groups_phases.edit.temp_body!=="<p><br></p>" ? '':
												<small className="help has-text-danger">Mensaje requerido</small>}
										</div>
									</div>
									<div className="field has-addons">
										<div className="control">
											<label htmlFor="groups_phase" className="label">Notificación <span className="small has-text-danger">*</span></label>
											<div className="select">
												<Control.select model=".temp_notification_id"
												                name="temp_notification_id"
												                id="temp_notification_id"
												                value={version_groups_phases.edit.temp_notification_id ? version_groups_phases.edit.temp_notification_id:""}>
													<option value="">-- Seleccionar Notificación --</option>
													{_.map(notifications_types.list, (opt, k) => {
														return <option key={k} value={opt.id}>{opt.name}</option>
													})}
												</Control.select>
											</div>
											{version_groups_phases.edit.temp_notification_id ? '':
												<small className="help has-text-danger">Notificación requerida</small>}
										</div>

										<div className="control">
											<label className="label">&nbsp;</label>
											<button type="button" className="button is-info" onClick={() => {this._addNotification()}}>Agregar</button>
										</div>
									</div>
								</div>
							</div> :
							<div className="hero-body">
								<p className="has-text-danger">No tienes permisos para editar notificaciones</p>
							</div>}

							{(!_.isEmpty(version_groups_phases.edit.notifications_types)) &&
								<div className="hero-body">
									<div className="hero-subsection">
										<h5 className="title is-5">Listado de Notificaciones</h5>
										<table className="table is-fullwidth project-goal-table">
											<thead>
											<tr>
												<th>#</th>
												<th>Nombre</th>
												<th>Modalidad</th>
												<th>Acciones</th>
											</tr>
											</thead>
											<tbody>
											{_.map(version_groups_phases.edit.notifications_types,(row, k) => {
												let modality = _.find(modalities.list,{id: row.modality_id})
												return [
													<tr key={k}>
														<td className="goal-cell" style={{width:'5%'}}>
															<strong>{k+1}</strong>
														</td>
														<td ><strong>{row.name}</strong></td>
														<td style={{width:'15%'}}><strong>{modality ? modality.name:'---'}</strong></td>
														<td style={{width:'10%'}}>
															{this.state.modalNotificationShow && this.state.notificationIndex === k ?
																<ModalNotificationEdit active={this.state.modalNotificationShow} notificationIndex={k} data={row} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
															<div className="field is-grouped">
																{gpu ?
																<div className="control">
																	<button type="button" className="button is-info" onClick={() => this._editNotification(k, row.modality_id, row.body)}><i className="fa fa-edit" /></button>
																</div>:''}
																{gpd ?
																<div className="control">
																	<button type="button" onClick={() => this._getConfirmNotification(k, row.name)} className="button is-danger"><i className="fa fa-trash" /></button>
																</div>:''}
															</div>
														</td>
													</tr>
												]
											})}
											</tbody>
										</table>
									</div>
								</div>
							}
						</div>
						}

					{(this.state.tabId === 4) &&
						<div className="hero is-light">
							<div className="hero-body">
								<h5 className="title is-5">Añadir proyectos</h5>

								<div className="hero-subsection">
									<div className="field is-grouped">
										<div className="control">
											<label htmlFor="temp_modality_id" className="label">Modalidad <span className="small has-text-danger">*</span></label>
											<div className="select">
												<Control.select model=".temp_modality_id" id="temp_modality_id" parser={ toInt } >
													<option value=" " defaultValue>--- Modalidad ---</option>
													{_.map(modalities.list,(option, k) => {
														return <option value={option.id} key={k}>{option.name}</option>
													})}
												</Control.select>
											</div>
										</div>

										{version_groups_phases.edit.temp_modality_id === 2 ?
											<div className="control">
												<label htmlFor="temp_state_id" className="label">Estado</label>
												<div className="select">
													<Control.select model=".temp_state_id" parser={ toInt }>
														<option value="">-- Estados --</option>
														{_.map(entities.list,(state,k) => {
															return <option value={state.id} key={k}>{state.name}</option>
														})}
													</Control.select>
												</div>
											</div>
											:''}

										<div className="control">
											<label className="label">&nbsp;</label>
											<div className="tags has-addons">
												<span className="tag is-primary is-large" >Proyectos</span>
												<span className="tag is-inm-purple is-large">{_.size(version_groups_phases.edit.projects)}</span>
											</div>
										</div>
									</div>
								</div>

								<hr/>

								{version_groups_phases.edit.temp_modality_id ?
								<div className="hero-subsection">
									<h5 className="title is-5">Listado de proyectos</h5>
									<table className="is-fullwidth table project-goal-table no-margin">
										<Fieldset model=".projects" component="tbody">
										{_.map(this._projectsList(version_groups_phases.edit.temp_modality_id, version_groups_phases.edit.temp_state_id), (item, k) => {
											let initial = _.findKey(version_groups_phases.edit.projects, {id:item.id}) !== undefined ? 1 : 0;
											return [
												<tr key={`project-${k}`}>
													<td className="goal-cell" style={{width: '10%'}}>
														<span className="help is-white">Agregar</span>
														<div className="field">
															<div className="control" onClick={() => this._addProject(item.id)}>
																<Rating ref={`project-add-${item.id}`}
																        id={`project-add-${item.id}`}
																        initialRating={initial}
																        start={0} stop={1} step={1}
																        emptySymbol="fa fa-square-o fa-2x"
																        fullSymbol="fa fa-check-square-o fa-2x"
																		className="has-text-white"/>
															</div>
														</div>
													</td>
													<td className="goal-cell">
														<span className="help is-white">Instancia</span>
														<strong>{item.agency ? item.agency.name:'---'}</strong>
													</td>
													<td className="goal-cell" style={{width: '30%'}}>
														{version_groups_phases.edit.temp_modality_id !== 2 ?
															<span className="help is-white">Estado</span>:
															<span className="help is-white">Municipio</span>}

														<strong>{item.agency ? item.agency.agenciable.name:'---'}</strong>
													</td>
												</tr>,
												<tr key={`general-${k}`}>
													<td colSpan={2}>
														<span className="help is-dark">Proyecto</span>
														<strong>{item.name  ? item.name:'---'}</strong>
													</td>
													<td>
														<span className="help is-dark">Titular</span>
														<strong>{item.agency && item.agency.owner  ? `${item.agency.owner.name} ${item.agency.owner.last_name} ${item.agency.owner.slast_name}`:'---'}</strong>
													</td>
												</tr>

											]
										})}
										</Fieldset>
									</table>
								</div> :''}
							</div>
						</div>
					}

					<div className="row">
						<div className="column">
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-large" onClick={() => this.props.history.push(`/versiones/editar/${match.params.year}`)}>Regresar</button>
								</div>
								<div className="control">
									<Control.button model="version_groups_phases.edit" className="button is-large is-inm-purple" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
								</div>
							</div>
							<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
						</div>
					</div>
				</Form>
			</div>
		)
	}

	constructor(props) {
		super(props);
		this.state = {
			editPhase: false,
			modalPhaseShow: false,
			modalNotificationShow: false,
			modalSurveysShow: false,
			phaseId: undefined,
			phaseIndex: undefined,
			notificationIndex: undefined,
			tabId: 1
		}
		this._changeTab = this._changeTab.bind(this);
	}

	_submitForm(values) {
		//console.log('values: ',values);
		let {year} = this.props.match.params;
		this.props.versionGroupsPhasesEditSave(year, values);
	}

	_changeTab(id){
		return this.setState({
			tabId: id
		})
	}

	_addSurveys(){
		let { version_groups_phases, surveys, modalities } = this.props;
		let surveysData = _.find(surveys.list,{id: version_groups_phases.edit.temp_survey_id})

		if(version_groups_phases.edit.temp_all_mods){
			this.props.add('version_groups_phases.edit.temp_survey_version_phases',{
				...surveysData,
				survey_id: version_groups_phases.edit.temp_survey_id,
			})
		}else {
			let modality = _.find(modalities.list, {id: version_groups_phases.edit.temp_modality_id})
			this.props.add('version_groups_phases.edit.temp_survey_version_phases',{
					...surveysData,
				survey_id: version_groups_phases.edit.temp_survey_id,
				modality_id: version_groups_phases.edit.temp_modality_id,
				modality
			})
		}

		this.props.change('version_groups_phases.edit.temp_survey_id',undefined);
		this.props.change('version_groups_phases.edit.temp_modality_id',undefined);
		this.props.change('version_groups_phases.edit.temp_all_mods',undefined);
	}

	_validSurvey(){
		let {version_groups_phases, phases} = this.props;
		let response = true;
		let phaseData = version_groups_phases.edit.temp_id_phase ? _.find(phases.list,{id: _.toNumber(version_groups_phases.edit.temp_id_phase)}):undefined;

		if(phaseData && phaseData.require_survey && !_.isEmpty(version_groups_phases.edit.temp_survey_version_phases)){
			let validMods = _.find(version_groups_phases.edit.temp_survey_version_phases,(o) => o.modality_id === undefined);
			//console.log('validMods', validMods);
			if (validMods){
				response = false;
			}else {
				let mod1 = this._validMod(1);
				let mod2 = this._validMod(2);
				let mod3 = this._validMod(3);
				if(mod1 && mod2 && mod3){
					response = false;
				}else {
					response = true;
				}
			}
		}else {
			response = true
		}

		return response;
	}

	_validMod(id){
		let {version_groups_phases} = this.props;
		let response = false;
		if(_.find(version_groups_phases.edit.temp_survey_version_phases,{modality_id: id})){
			response = true;
		}else {
			response = false;
		}

		return response;
	}

	_validPhase(id){
		let {version_groups_phases} = this.props;
		let response = false;
		if(_.find(version_groups_phases.edit.phases,{id: _.toNumber(id)})){
			response = true;
		}else {
			response = false;
		}
		return response;
	}

	_addPhase(){
		let { version_groups_phases, phases } = this.props;
		if(version_groups_phases.edit.temp_p_start_date !== undefined &&
			version_groups_phases.edit.temp_p_end_date!== undefined &&
			version_groups_phases.edit.temp_id_phase!== undefined){
			let phase = _.find(phases.list, {id: _.toInteger(version_groups_phases.edit.temp_id_phase)});

			if(phase.require_survey && !_.isEmpty(version_groups_phases.edit.temp_survey_version_phases)){
				this.props.add(`version_groups_phases.edit.phases`, {
					...phase,
					start_date: version_groups_phases.edit.temp_p_start_date,
					end_date: version_groups_phases.edit.temp_p_end_date,
					survey_version_phases: version_groups_phases.edit.temp_survey_version_phases
				});

				this.props.change(`version_groups_phases.edit.temp_id_phase`, undefined);
				this.props.change(`version_groups_phases.edit.temp_p_start_date`, undefined);
				this.props.change(`version_groups_phases.edit.temp_p_end_date`, undefined);
				this.props.change(`version_groups_phases.edit.temp_survey_version_phases`, undefined);

			}else {
				this.props.add(`version_groups_phases.edit.phases`, {
					...phase,
					start_date: version_groups_phases.edit.temp_p_start_date,
					end_date: version_groups_phases.edit.temp_p_end_date
				});

				this.props.change(`version_groups_phases.edit.temp_id_phase`, undefined);
				this.props.change(`version_groups_phases.edit.temp_p_start_date`, undefined);
				this.props.change(`version_groups_phases.edit.temp_p_end_date`, undefined);
			}
		}
	}

	_editPhase(id){
		this.setState({
			editPhase: true,
			phaseId: id
		})
	}

	_savePhase(phaseId){
		let { version_groups_phases } = this.props;
		let phaseIndex = _.findIndex(version_groups_phases.edit.phases,{id: phaseId});

		this.setState({
			editPhase: false,
			phaseId: undefined
		})
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].start_date`, version_groups_phases.edit.phases[phaseIndex].temp_start_date);
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].end_date`, version_groups_phases.edit.phases[phaseIndex].temp_end_date);
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].temp_start_date`, undefined);
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].temp_end_date`, undefined);

		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].report_start_date`, version_groups_phases.edit.phases[phaseIndex].temp_report_start_date);
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].report_end_date`, version_groups_phases.edit.phases[phaseIndex].temp_report_end_date);
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].temp_report_start_date`, undefined);
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].temp_report_end_date`, undefined);
	}

	_getConfirm(phaseId, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la fase "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._removePhase(phaseId)
		})
	}

	_removePhase(phaseId){
		let { version_groups_phases } = this.props;
		let phaseIndex = _.findIndex(version_groups_phases.edit.phases,{id: phaseId});
		this.props.remove(`version_groups_phases.edit.phases`,phaseIndex);
	}

	_closePhase(phaseId){
		let { version_groups_phases } = this.props;
		let phaseIndex = _.findIndex(version_groups_phases.edit.phases,{id: phaseId});
		this.setState({
			editPhase: false,
			phaseId: undefined
		})
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].temp_start_date`,undefined);
		this.props.change(`version_groups_phases.edit.phases[${phaseIndex}].temp_end_date`,undefined);
	}

	_addNotification(){
		let { version_groups_phases, notifications_types } = this.props;
		if(version_groups_phases.edit.temp_notification_id !== undefined &&
			version_groups_phases.edit.temp_modality_id!== undefined &&
			(version_groups_phases.edit.temp_body!== undefined || version_groups_phases.edit.temp_body!== null)){
			let notification = _.find(notifications_types.list, {id: _.toInteger(version_groups_phases.edit.temp_notification_id)});

			this.props.add(`version_groups_phases.edit.notifications_types`, {
				...notification,
				id: version_groups_phases.edit.temp_notification_id,
				modality_id: version_groups_phases.edit.temp_modality_id,
				body: version_groups_phases.edit.temp_body
			});
			this.props.change(`version_groups_phases.edit.temp_notification_id`, undefined);
			this.props.change(`version_groups_phases.edit.temp_modality_id`, undefined);
			this.props.change(`version_groups_phases.edit.temp_body`, null);
		}
	}

	_editNotification(index, modalityId, body){
		this.props.change(`version_groups_phases.edit.notifications_types[${index}].temp_modality_id`,undefined);
		this.props.change(`version_groups_phases.edit.notifications_types[${index}].temp_body`,null);

		this.props.change(`version_groups_phases.edit.notifications_types[${index}].temp_modality_id`,modalityId);
		this.props.change(`version_groups_phases.edit.notifications_types[${index}].temp_body`,body);

		this.setState({
			modalNotificationShow: true,
			notificationIndex: index
		})
	}

	_getConfirmNotification(index, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la notificación "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._removeNotification(index)
		})
	}

	_removeNotification(index){
		this.props.remove(`version_groups_phases.edit.notifications_types`,index);
	}

	_editSurveys(id){
		let {version_groups_phases} = this.props;

		let index = _.findIndex(version_groups_phases.edit.phases, {id: _.toNumber(id)})

		this.props.change(`version_groups_phases.edit.phases[${index}]`,{
			...version_groups_phases.edit.phases[index],
			phaseIndex: index,
			temp_survey_version_phases: version_groups_phases.edit.phases[index].survey_version_phases
		})

		this.setState({
			modalSurveysShow: true,
			phaseId: id
		})
	}

	_toggleModal() {
		this.setState({
			modalNotificationShow: false,
			modalSurveysShow: false,
			notificationIndex: undefined,
			phaseId: undefined
		});
	}

	_projectsList(mod, state){
		let {projects} = this.props;
		let list = [];
		if(mod && mod !== 2){
			list = _.filter(projects.list, {modality_id: mod})
		}else if(mod && state){
			list = _.filter(projects.list, {modality_id: mod, agency: {agenciable: {state_id: state}}})
		}

		return list;
	}

	_changeAllProject(model, value){
		let {edit} = this.props.version_groups_phases;
		let {list} = this.props.projects;
		this.props.change(model,value);
		if(!value){
			if(edit.version_phase_group.version_id && _.isEmpty(list)){
				this.props.fetchEntities();
				this.props.fetchProjectsList(edit.version_phase_group.version_id);
			}
		}else {
			this._changeTab(1);
			this.props.change('version_groups_phases.edit.projects',[]);
		}
	}

	_addProject(projectId){
		let {projects} = this.props.version_groups_phases.edit;

		let projectsIndex = _.findIndex(projects, {id: projectId});
		if(this.refs[`project-add-${projectId}`].state.value === 0){
			if(projectsIndex === -1){
				this.props.add(`version_groups_phases.edit.projects`,{
					id: projectId
				})
			}else {
				this.props.change(`version_groups_phases.edit.projects[${projectsIndex}]`,{
					id: projectId
				})
			}
		}else{
			if(projectsIndex !== -1){
				this.props.remove(`version_groups_phases.edit.projects`,projectsIndex)
			}
		}
	}

	_validateSave(){
		const {version_groups_phases} = this.props;
		let gpc = _.find(version_groups_phases.permissions, (o) => {return o==='Create'});
		let gpu = _.find(version_groups_phases.permissions, (o) => {return o==='Update'});
		let gpd = _.find(version_groups_phases.permissions, (o) => {return o==='Delete'});

		if(gpc || gpu || gpd ){
			return false;
		}else {
			return true;
		}
	}
}

class ModalNotificationEdit extends Component {
	render() {
		let {data, version_groups_phases, modalities, notificationIndex} = this.props;
		let index = notificationIndex;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">{data.name}</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						<Fieldset model={`version_groups_phases.edit.notifications_types[${index}]`}>
							<div className="field">
								<div className="control">
									<label htmlFor="temp_modality_id" className="label">Modalidad <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select model=".temp_modality_id" id="temp_modality_id" parser={ toInt }>
											<option value=" " defaultValue>--- Modalidad ---</option>
											{modalities.list.map((option, k) => {
												return <option value={option.id} key={k}>{option.name}</option>
											})}
										</Control.select>
									</div>
									{version_groups_phases.edit.notifications_types[index].temp_modality_id ? '':
										<small className="help has-text-danger">Mensaje requerido</small>}
								</div>
							</div>

							<div className="field">
								<div className="control">
									<label className="label">Claves</label>
									<p>Las siguientes claves pueden ser escritas en la edición mensaje</p>
									<p>{'{#asesor_name#} '} = Nombre Asesor</p>
									<p>{'{#asesor_email#} '} = Email Asesor</p>
									<p>{'{#asesor_extension#} '} = Extensión Asesor</p>
									<label htmlFor="temp_body" className="label">Mensaje para notificacion <span className="small has-text-danger">*</span></label>
									<Control.textarea model=".temp_body" id=".temp_body" component={TextEditor}/>
									{version_groups_phases.edit.notifications_types[index].temp_body ? '':
										<small className="help has-text-danger">Mensaje requerido</small>}
								</div>
							</div>

							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-danger" onClick={this.props.closeModal}>
										Cerrar
									</button>
								</div>
								<div className="control">
									<button type="button" className="button is-success" onClick={() => this._saveNotification()}>
										Guardar
									</button>
								</div>
							</div>
						</Fieldset>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		)
	}

	_saveNotification(){
		let {data, version_groups_phases, notificationIndex} = this.props;
		let index = notificationIndex;

		this.props.change(`version_groups_phases.edit.notifications_types[${index}]`,{
			...data,
			modality_id: version_groups_phases.edit.notifications_types[index].temp_modality_id,
			body: version_groups_phases.edit.notifications_types[index].temp_body
		})

		this.props.change(`version_groups_phases.edit.notifications_types[${index}].temp_modality_id`,undefined);
		this.props.change(`version_groups_phases.edit.notifications_types[${index}].temp_body`,null);

		this.props.closeModal();
	}
}

class ModelSurveysEdit extends Component{
	render(){
		let {data, surveys, modalities} = this.props;
		let validMods = _.find(data.temp_survey_version_phases,(o) => (o.modality_id !== undefined || o.modality_id !== null));
		return(
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={() => this._closeSurveyModal()}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">{data.name}</p>
						<button type="button" onClick={() => this._closeSurveyModal()} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{this._validSurvey() && _.isEmpty(validMods) ?
							<div className="field is-grouped">
								<div className="control">
									<div className="message is-success">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="temp_all_mods" className="checkbox">
														<Control.checkbox model=".temp_all_mods" id="temp_all_mods" className="checkbox" isToggle={true}/>
														<span style={{whiteSpace:'normal'}}> Aplica para todas las modalidades </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>:''}

						{this._validSurvey() ?
							<div className="field is-grouped-multiline">
								<div className="control">
									<label htmlFor="groups_phase" className="label">Encuesta <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select model=".temp_survey_id"
										                name="temp_survey_id"
										                id="temp_survey_id"
										                parser={ toInt }>
											<option value="">-- Seleccionar Encuesta --</option>
											{_.map(surveys.list, (opt, k) => {
												return <option key={k} value={opt.id}>{opt.name}</option>
											})}
										</Control.select>
									</div>
									{data.temp_survey_id ? '':
										<small className="help has-text-danger">Encuesta requerido</small>}
								</div>

								{!data.temp_all_mods ?
									<div className="control">
										<label htmlFor="temp_modality_id" className="label">Modalidad</label>
										<div className="select">
											<Control.select model=".temp_modality_id" id="temp_modality_id" parser={ toInt } >
												<option value="" defaultValue>--- Modalidad ---</option>
												{_.map(modalities.list,(option, k) => {
													return <option value={option.id} key={k}>{option.name}</option>
												})}
											</Control.select>
										</div>
									</div> :''}

								<div className="control">
									<label className="label">&nbsp;</label>
									<button type="button" className="button is-info" onClick={() => this._addSurveys()} disabled={this._validMod(data.temp_modality_id)}>Agregar</button>
								</div>
							</div>:''}

						{_.map(data.temp_survey_version_phases, (row, s) => {
							return (
								<span className="tag is-success is-medium" key={s}>
									{`${row.survey ? row.survey.name:row.name}${row.modality_id ? ` - ${row.modality.name}`:''}`}
									<button type="button" className="delete"
									        onClick={() => this.props.remove(`version_groups_phases.edit.phases[${data.phaseIndex}].temp_survey_version_phases`,s)}>
									</button>
								</span>
							)
						})}

						<br/><br/>
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-danger" onClick={() => this._closeSurveyModal()}>
									Cerrar
								</button>
							</div>
							<div className="control">
								<button type="button" className="button is-success" onClick={() => this._saveSurveys()}>
									Guardar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	_validSurvey(){
		let {data} = this.props;
		let response = true;

		if(!_.isEmpty(data.temp_survey_version_phases)){
			let validMods = _.find(data.temp_survey_version_phases,(o) => (o.modality_id === undefined || o.modality_id === null));
			//console.log('validMods', validMods);
			if (validMods){
				response = false;
			}else {
				let mod1 = this._validMod(1);
				let mod2 = this._validMod(2);
				let mod3 = this._validMod(3);
				if(mod1 && mod2 && mod3){
					response = false;
				}else {
					response = true;
				}
			}
		}else {
			response = true
		}

		return response;
	}

	_validMod(id){
		let {data} = this.props;
		let response = false;
		if(_.find(data.temp_survey_version_phases,{modality_id: id})){
			response = true;
		}else {
			response = false;
		}

		return response;
	}

	_addSurveys(){
		let { data, surveys, modalities } = this.props;
		let surveysData = _.find(surveys.list,{id: data.temp_survey_id})

		if(data.temp_all_mods){
			this.props.add(`version_groups_phases.edit.phases[${data.phaseIndex}].temp_survey_version_phases`,{
				...surveysData,
				survey_id: data.temp_survey_id,
			})
		}else {
			let modality = _.find(modalities.list, {id: data.temp_modality_id})
			this.props.add(`version_groups_phases.edit.phases[${data.phaseIndex}].temp_survey_version_phases`,{
				...surveysData,
				survey_id: data.temp_survey_id,
				modality_id: data.temp_modality_id,
				modality
			})
		}

		this.props.change(`version_groups_phases.edit.phases[${data.phaseIndex}].temp_survey_id`,undefined);
		this.props.change(`version_groups_phases.edit.phases[${data.phaseIndex}].temp_modality_id`,undefined);
		this.props.change(`version_groups_phases.edit.phases[${data.phaseIndex}].temp_all_mods`,undefined);
	}

	_saveSurveys(){
		let { data } = this.props;
		this.props.change(`version_groups_phases.edit.phases[${data.phaseIndex}].survey_version_phases`, data.temp_survey_version_phases);
		this.props.change(`version_groups_phases.edit.phases[${data.phaseIndex}].temp_survey_version_phases`, undefined);
		this.props.closeModal();
	}

	_closeSurveyModal(){
		let { data } = this.props;
		this.props.change(`version_groups_phases.edit.phases[${data.phaseIndex}].temp_survey_version_phases`, undefined);
		this.props.closeModal();
	}
}


// WEBPACK FOOTER //
// ./src/elements/versions/version_group_phase.jsx